var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type=='message')?[_c('message-viewer',{model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})]:_vm._e(),_vm._v(" "),(_vm.type=='generic')?[_c('generic-viewer',{model:{value:(_vm.generics),callback:function ($$v) {_vm.generics=$$v},expression:"generics"}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408f413b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/intent/IntentGetstarted.vue
// module id = null
// module chunks = 